exports.value = "v2.5.0-rc.2";